import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { API_PATHS } from '../../service/api';
import { BaggageReallocationState } from '../../types';
import { milisecondsBeforeReestablishingConnectionToBackendAfterLostConnection } from '../../utils/timers';

enum actionTypes {
	getBaggageReallocationState = 'baggageReallocationState/get',
	updateBaggageReallocationState = 'baggageReallocationState/update/get'
}

let requestRunning: boolean = false;

export const getBaggageReallocationState = createAsyncThunk(
	actionTypes.getBaggageReallocationState,
	async (_, thunkAPI) => {
		if (!requestRunning) {
			requestRunning = true;
			try {
				const response = await api.get<BaggageReallocationState>(
					API_PATHS.reallocationState + `?fullState=true`
				);
				const lastModifiedHeader = response.headers['bagstage-last-modified'];
				requestRunning = false;

				thunkAPI.dispatch(updateBaggageReallocationState(lastModifiedHeader));
				return response.data;
			} catch (error: any) {
				requestRunning = false;
				setTimeout(() => {
					thunkAPI.dispatch(getBaggageReallocationState());
				}, milisecondsBeforeReestablishingConnectionToBackendAfterLostConnection);
				throw error;
			}
		}
	}
);

export const updateBaggageReallocationState = createAsyncThunk(
	actionTypes.updateBaggageReallocationState,
	async (lastModified: string, { dispatch }) => {
		if (!requestRunning) {
			requestRunning = true;
			try {
				const response = await api.get<BaggageReallocationState>(API_PATHS.reallocationState, {
					params: {
						bagstageIfModifiedSince: lastModified // send as query param
					}
				});
				const lastModifiedHeader = response.headers['bagstage-last-modified'];
				requestRunning = false;

				if (response.status === 200) {
					dispatch(updateBaggageReallocationState(lastModifiedHeader));
					return response.data;
				}
			} catch (error: any) {
				requestRunning = false;
				if (error && (!error.response || error.response.status >= 400)) {
					setTimeout(() => {
						dispatch(getBaggageReallocationState());
					}, milisecondsBeforeReestablishingConnectionToBackendAfterLostConnection);
					throw error;
				}
				if (error.response.status === 304) {
					dispatch(updateBaggageReallocationState(lastModified));
					return;
				}
			}
		}
	}
);
